import React from 'react';
import MyDevices from '../MyDevices';
import { User } from "../../types";
import { API_BASE_URL } from '../../config/api';
import { publicUrl } from '../../config/hosts';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';

interface CustomerViewProps {
  user: User;
  onLogout: () => void;
}

const CustomerView: React.FC<CustomerViewProps> = ({ user, onLogout }) => {
  return (
    <div className="container mt-4 mb-3" style={{ maxWidth: '1400px' }}>
      <div className="d-flex justify-content-between align-items-center border-bottom pb-3">
        <div>
          <h1>{user.firstName} {user.lastName}</h1>
          <h4>Customer</h4>
          <div className="text-muted">{user.email}</div>
        </div>
        <button className="btn btn-danger" onClick={onLogout}>
          Logout
        </button>
      </div>

      <div className="mt-4">
        <div className="card mb-4">
          <div className="card-body">
            <h5 className="card-title">Your Devices</h5>
            <MyDevices
              apiBaseUrl={API_BASE_URL}
              readOnly
            />
          </div>
        </div>

        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Public Links</h5>
            <div className="d-flex flex-wrap gap-2">
              <a href={publicUrl('/releases')} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                Releases <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-1" />
              </a>
              <a href={publicUrl('/mobile-app')} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                Mobile App <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-1" />
              </a>
              <a href={publicUrl('/download')} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                Firmware Download <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-1" />
              </a>
              <a href={publicUrl('/legacy')} target="_blank" rel="noopener noreferrer" className="btn btn-outline-secondary">
                Legacy Download <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="ms-1" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerView;
